import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import Container from '../../components/shared/atoms/Container';
import Box from '../../components/shared/atoms/Box';
import Heading from '../../components/shared/atoms/Heading';
import BuyGiftCardHeroBox from '../../components/giftcard/buyGiftcard/BuyGiftCardHeroBox';
import LoginModal from '../../components/giftcard/LoginModal';

const BuyGiftCard = () => {
  const { t } = useTranslation();
  const client = useSelector((s) => s.client);
  const history = useHistory();
  const rawGiftcardFromLanding = history.location.state
    ? history.location.state.giftcardFromLanding
      ? history.location.state.giftcardFromLanding
      : null
    : null;

  const normalizedGiftcardFromLanding =
    rawGiftcardFromLanding &&
    rawGiftcardFromLanding.giftcardChoice >= 1 &&
    rawGiftcardFromLanding.giftcardChoice <= 3
      ? rawGiftcardFromLanding
      : rawGiftcardFromLanding
      ? { ...rawGiftcardFromLanding, giftcardChoice: 1 }
      : null;

  const [giftcard, setGiftcard] = useState(
    normalizedGiftcardFromLanding || {
      giftcardChoice: 1,
      recipientName: '',
      errorName: false,
      message: '',
      amount: 20,
      customAmount: '',
      errorAmount: false,
      code: '',
      created_at: '',
      id: '',
    },
  );

  const [steps, setSteps] = useState('CUSTOMIZATION');
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <Container fluid>
      <Helmet
        title="Acheter une carte cadeau | Roulez Jeunesse"
        meta={[
          {
            name: 'description',
            content:
              'Offrez une réparation vélo à domicile avec la carte cadeau Roulez Jeunesse.',
          },
          { name: 'twitter:card', content: 'summary_large_image' },
          {
            name: 'twitter:title',
            content: 'Acheter une carte cadeau | Roulez Jeunesse',
          },
          {
            name: 'twitter:description',
            content:
              'Offrez une réparation vélo à domicile avec la carte cadeau Roulez Jeunesse.',
          },
          {
            name: 'twitter:image',
            content:
              'https://uploads-ssl.webflow.com/664e20aae5145eb7a61de885/666854745cce5ad6c682189f_Re%CC%81parer%20son%20ve%CC%81lo%20devient%20un%20jeu%20d%E2%80%99enfant.png',
          },
        ]}
      />
      <LoginModal
        showModal={showModal}
        setShowModal={setShowModal}
        loginFirst={true}
      />
      <Box zIndex={0} display={{ xs: 'none', md: 'block' }}>
        <img
          src="/static/img/photos/giftcard/buy_gift_card_banner.jpg"
          alt="Acheter une carte cadeau réparation vélo Roulez Jeunesse"
          style={{
            width: '100%',
            maxHeight: 380,
            objectFit: 'cover',
            borderRadius: 24,
          }}
        />
      </Box>
      <Heading level={1} textAlign="center" mt={7}>
        {t('buygiftcard.heading')}
      </Heading>
      <Container style={{ zIndex: 1, position: 'relative' }}>
        <BuyGiftCardHeroBox
          giftcard={giftcard}
          setGiftcard={setGiftcard}
          client={client}
          setShowModal={setShowModal}
          loading={loading}
          setLoading={setLoading}
          steps={steps}
          setSteps={setSteps}
        />
      </Container>
    </Container>
  );
};

export default BuyGiftCard;
